export enum ApiCommand {
    DRIVER_PROFILE = 'driverProfile',
    LOAD_DETAILS = 'loadDetails',
    LOAD_HISTORY = 'loadHistory',
    PHOTO_LIST = 'photoList',
    TRAINEE_SEARCH = 'traineeSearch',
    TRAINEE_PROFILE = 'traineeProfile',
    TRAINEE_COURSE_ASSIGN = 'traineeCourseAssign',
    TRAINEE_RELEASE = 'traineeRelease',
    TRAINEE_CLAIM = 'traineeClaim',
    TRAINING_REPORTS_GET = 'trainingReportsGet',
    TRAINING_REPORTS_GET_2 = 'trainingReportsGet2',
    TRAINING_REPORT_GET_2 = 'trainingReportGet2',
    TRAINING_REPORT_BACKING = 'trainingReportBacking',
    TRAINING_REPORT_SUBMIT_2 = 'trainingReportSubmit2',
    TRAINING_REPORT_DAY_PASSED_2 = 'trainingReportDayPassed2',
    TRAINING_COURSE_GET = 'trainingCourseGet',
    TRAINING_COURSES_GET = 'trainingCoursesGet',
    TRAINING_PROMPTS_GET = 'trainingPromptsGet',
    TRAINER_FEEDBACK = 'trainerFeedback',
    DRIVER_SSN = 'driverSSN',
    DOCS_LIST = 'docsList2',
    GENERIC_EMAIL = 'genericEmail',
    GENERIC_FILE_EMAIL = 'genericFileEmail2',
    USER_LOGOUT = 'userLogout',
    LEADERBOARD = 'leaderboard2',
    USER_GET = 'userGet',
    USER_STATE_GET = 'userStateGet',
    PUSH_NOTIFICATIONS_GET = 'pushNotificationsGet',
    PUSH_NOTIFICATION_READ = 'pushNotificationRead',
    PREPLANNED_LOADS_GET = 'preplannedLoadsGet',
    VIDEOS_GET = 'videosGet',
    CONTACTS_GET = 'contactsGet',
    DM_GET = 'dmGet',
    ROAD_TEST_SUBMIT = 'roadTestSubmit',
    VEHICLE_REGISTER = 'vehicleRegister',
    PAYROLL_OVERVIEW = 'payrollOverview',
    GAMIFICATION_DRIVER_2 = 'gamificationDriver2',
    INBOX_SEND_MESSAGE = 'inboxSendMessage',
    INSPECTION_SUBMISSION = 'inspectionSubmission',
    CASH_ADVANCE = 'cashAdvance',
    CASH_ADVANCES_GET = 'cashAdvancesGet',
    CASH_ADVANCE_ELIGIBILITY = 'cashAdvanceEligibility',
    PAYCHECK_HISTORY = 'paycheckHistory',
    ORIENTATION_UPDATE = 'orientationUpdate',
    REGISTER_DEVICE_TOKEN = 'registerDeviceToken',
    ORIENTATION_EVAL_SUBMIT = 'orientationEvalSubmit',
    ORIENTATION_DRIVER_LIST = 'orientationDriverList',
    TENSTREET_DOCUMENT = 'tenstreetDocument',
    NEWS_ARTICLES_GET = 'newsArticlesGet',
    INBOX_GET_ALL_MESSAGES = 'inboxGetAllMessages',
    HELP_REQUEST = 'helpRequest',
    FAQ_ENTRIES_GET = 'faqEntriesGet',
    PHOTO_SUBMISSION = 'photoSubmission',
    TRAILER_REJECT = 'trailerReject',
    DRIVER_PROFILE_UPDATE = 'driverProfileUpdate',
    LP_INSPECTION_SUBMISSION = 'lpInspectionSubmission',
    LP_INSPECTIONS_GET = 'lpInspectionsGet',
    GENERIC_REPORT_SUBMISSION = 'genericReportSubmission',
    TRAILER_LOCATION = 'trailerLocation',
    TRAILER_CONNECT = 'trailerConnect',
    TRAILER_LOCATION_GET = 'trailerLocationGet',
    TRAILER_CUST_POLY = 'trailersCustPoly',
    ROUTE_COMPUTE = 'routeCompute',
    USER_CREATE = 'userCreate',
    USER_UPDATE = 'userUpdate',
    LP_LOGIN = 'universalLogin',
    BROADCAST_MESSAGE_GET = 'broadcastMessageGet',
    POLL_RESULT_SUBMIT = 'pollResultSubmit',
    USER_GET_RESET_TOKEN = 'userGetResetToken',
    USER_RESET_TOKEN_VERIFY = 'userResetTokenVerify',
    USER_RESET_PASSWORD = 'userResetPassword',
    LP_SETTLEMENTS_GET = 'lpSettlementsGet',
    LP_SETTLEMENT_GET = 'lpSettlementGet2',
    TOP_LOADS_GET = 'topLoadsGet',
    TOP_LOAD_ACCEPT = 'topLoadAccept',
    DEFERMENTS_GET = 'defermentsGet',
    DEFERMENT_CREATE = 'defermentCreate',
    PHOTO_CHECKSUM = 'photoChecksum',
    PHOTO_CHECKSUM_REVOKE = 'photoChecksumRevoke',
    OWNER_GET = 'ownerGet',
    LP_DOC_UPLOAD = 'lpDocUpload',
    UNIT_MILEAGE = 'unitMileage',
    UNIT_GET = 'unitGet',
    CHAT_CONVERSATION_CREATE = 'chatConversationCreate',
    CHAT_CONVERSATION_GET = 'chatConversationsGet',
    CHAT_CONVERSATION_POST = 'chatMessagePost',
    CHAT_MESSAGES_GET = 'chatMessagesGet',
    CHAT_USER_ADD = 'chatUserAdd',
    INBOX_GET_ALL_MESSAGES_2 = 'inboxGetAllMessages2',
    INBOX_SEND_MESSAGE_2 = 'inboxSendMessage2',
    INBOX_GET_MESSAGE2_2 = 'inboxGetMessages2',
    AGREEMENT_DATA_UPLOAD = 'agreementDataSet',
    AGREEMENT_DATA_GET = 'agreementDataGet',
    PAY_MATRIX = 'payMatrix',
    SYNERGIZE_UNIT_DOCUMENTS_GET = 'synergizeUnitDocumentsGet',
    // New API Commands
    GET_MOST_USED_PAGES = 'mostUsedGet',
    SAVE_MOST_USED_PAGES = 'mostUsedPost',
    TRAILER_ID_UPLOAD = 'trailerIdUpload'
}
